import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "form", "courseName", "optionRadio", "submit"];
  static values = {
    baseUrl: String
  };

  connect() {
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  open(event) {
    event.preventDefault();

    const courseId = event.currentTarget.dataset.courseId;
    const courseName = event.currentTarget.dataset.courseName;

    this.formTarget.action = this.baseUrlValue.replace(':id', courseId);
    this.courseNameTarget.textContent = courseName;

    this._reset();

    const modal = new Modal(this.modalTarget);
    modal.show();
  }

  optionChanged() {
    const anyChosen = this.optionRadioTargets.some(radio => radio.checked);
    this.submitTarget.disabled = !anyChosen;
  }

  _handleModalHidden() {
    this._reset();
  }

  _reset() {
    this.optionRadioTargets.forEach(radio => {
      radio.checked = false;
    });
    this.submitTarget.disabled = true;
  }
}
